(function() {
  const sentinel = document.querySelector('[data-pp-infinite-sentinel]');
  const tbody = document.getElementById('pp-table-tbody');
  if (!sentinel || !tbody) return;
  let nextUrl = (sentinel.dataset.nextUrl || '').trim();
  if (!nextUrl) return;

  const sectionId = (sentinel.dataset.sectionId || '').trim();
  if (!sectionId) return;

  const sectionIdNorm = sectionId.replace(/^shopify-section-/, '');
  let loading = false;

  function buildSectionUrl(url) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionIdNorm);
    return u.toString();
  }

  function getSectionHTMLFromResponse(text) {
    try {
      const json = JSON.parse(text);
      if (json && typeof json[sectionIdNorm] === 'string') return json[sectionIdNorm];
      if (json && json.sections && typeof json.sections[sectionIdNorm] === 'string') return json.sections[sectionIdNorm];
    } catch (e) {}
    return text;
  }

  function appendNextPage() {
    if (loading) return;
    const url = (sentinel.dataset.nextUrl || '').trim();
    if (!url) return;
    loading = true;
    sentinel.classList.add('pp-infinite-loading');

    fetch(buildSectionUrl(url))
      .then(function(r) { return r.text(); })
      .then(function(text) {
        const html = getSectionHTMLFromResponse(text);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const responseTbody = doc.querySelector('#pp-table-tbody');
        if (!responseTbody) return;
        const rows = responseTbody.querySelectorAll(':scope > tr');
        rows.forEach(function(tr) { tbody.appendChild(tr.cloneNode(true)); });

        const responseSentinel = doc.querySelector('[data-pp-infinite-sentinel]');
        if (responseSentinel && responseSentinel.dataset.nextUrl) {
          sentinel.dataset.nextUrl = responseSentinel.dataset.nextUrl;
        } else {
          sentinel.remove();
        }
        history.replaceState('', '', url);
        window.dispatchEvent(new CustomEvent('pp-table-rows-appended'));
      })
      .catch(function() {
        sentinel.classList.remove('pp-infinite-loading');
      })
      .finally(function() {
        loading = false;
        sentinel.classList.remove('pp-infinite-loading');
      });
  }

  const observer = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting) return;
    appendNextPage();
  }, { rootMargin: '400px', threshold: 0 });

  observer.observe(sentinel);
})();

(function() {
  let activeFilters = new Set();
  let activeQuickFilters = new Set();

  /** Toggle one value on native Shopify filter param; preserves other query params; clears page. */
  function ppBuildNativeGaugeUrl(filterParam, paramValue) {
    const url = new URL(window.location.href);
    const sp = url.searchParams;
    const raw = String(paramValue);
    const current = sp.getAll(filterParam);
    const isOn = current.some(function (v) { return String(v) === raw; });
    sp.delete(filterParam);
    if (isOn) {
      current.filter(function (v) { return String(v) !== raw; }).forEach(function (v) {
        sp.append(filterParam, v);
      });
    } else {
      current.forEach(function (v) { sp.append(filterParam, v); });
      sp.append(filterParam, raw);
    }
    sp.delete('page');
    var qs = sp.toString();
    return url.pathname + (qs ? '?' + qs : '') + (url.hash || '');
  }

  function escAttrHref(u) {
    return String(u).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function getGaugeFiltersConfig() {
    const el = document.getElementById('ppGaugeFiltersConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); }
    catch (e) { console.warn('Bad ppGaugeFiltersConfig JSON', e); return null; }
  }

  /**
   * Visually mirrors a Mode C group pill's active state onto the matching native gauge
   * checkbox in the left sidebar (data-gauge-value on the pill, matched to that filter's
   * paramValue) - cosmetic only, does not touch the URL or apply a real filter. Real
   * two-way native sync was rejected: applying the actual filter narrows collection.products
   * server-side, which collapses every other group's pill (see preselectGroupFromUrl's
   * comment on why Mode C avoids that). This keeps the sidebar checkbox from looking "stuck"
   * out of sync with the pill without sacrificing instant pill-to-pill switching.
   * Skips any checkbox whose value is already reflected by a real applied filter in the
   * URL, so this never fights an actual user-driven sidebar selection.
   */
  function ppCosmeticSyncGaugeCheckbox(gaugeValue, isActive) {
    if (gaugeValue == null || gaugeValue === '') return;
    const cfg = getGaugeFiltersConfig();
    if (!cfg || !cfg.filterParam) return;

    const reallyApplied = new URLSearchParams(window.location.search)
      .getAll(cfg.filterParam)
      .some(function (v) { return String(v) === String(gaugeValue); });
    if (reallyApplied) return;

    document.querySelectorAll('input[type="checkbox"][name]').forEach(function (input) {
      if (input.name !== cfg.filterParam) return;
      if (String(input.value) !== String(gaugeValue)) return;
      input.checked = isActive;
      const wrap = input.closest('.facets__inputs-list-item, .facets__pill-wrapper');
      if (wrap) wrap.classList.toggle('pp-cosmetic-checked', isActive);
    });
  }

  function getQuickFiltersConfig() {
    const el = document.getElementById('ppQuickFiltersConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); }
    catch (e) { console.warn('Bad ppQuickFiltersConfig JSON', e); return null; }
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function renderQuickFilters() {
    const cfg = getQuickFiltersConfig();
    const mount = document.getElementById('ppQuickFiltersMount');
    const cards = document.getElementById('ppQuickFilterCards');
    if (!mount || !cards) return;

    const filters = (cfg && Array.isArray(cfg.filters)) ? cfg.filters : [];
    if (!filters.length) {
      mount.style.display = 'none';
      return;
    }

    cards.innerHTML = filters.map(f => {
      const tag = String(f.tag || '').toLowerCase();
      const label = String(f.label || tag);
      // optional 3rd field in custom.quick_filters ("tag|Label|image URL"): same image block as the group cards
      const img = f.image ? `
          <div class="pp-filter-card__image">
            <img src="${escapeHtml(f.image)}" alt="${escapeHtml(label)}" loading="lazy" width="300" height="300">
          </div>` : '';
      return `
        <button type="button" class="pp-filter-card pp-quick-filter-card" data-qf-tag="${tag}">
          <div class="pp-filter-card__checkbox"></div>${img}
          <span class="pp-filter-card__title">${escapeHtml(label)}</span>
        </button>
      `;
    }).join('');

    mount.style.display = '';
  }

  /** Match URL param value to pill (handles string/number from JSON). */
  function gaugeParamSelected(selectedList, paramValue) {
    var t = String(paramValue);
    for (var i = 0; i < selectedList.length; i++) {
      if (String(selectedList[i]) === t) return true;
    }
    return false;
  }

  /** Instant pill active state when sidebar changes (before/without waiting for morph). */
  function syncGaugePillsFromQueryParams(qp) {
    if (!qp || typeof qp.getAll !== 'function') return;
    var cfg = getGaugeFiltersConfig();
    if (!cfg || !cfg.filterParam) return;
    var fp = cfg.filterParam;
    var selected = qp.getAll(fp).map(String);
    document.querySelectorAll('.pp-gauge-filter-card[data-pp-gauge-value]').forEach(function (el) {
      var raw = el.getAttribute('data-pp-gauge-value');
      if (raw == null || raw === '') return;
      var pv = raw;
      try {
        pv = decodeURIComponent(raw.replace(/\+/g, ' '));
      } catch (err) { /* keep raw */ }
      var on = gaugeParamSelected(selected, pv);
      el.classList.toggle('is-active', on);
      if (el.tagName === 'A' || el.tagName === 'a') {
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
  }

  function renderGaugeFilters(queryParams) {
    const cfg = getGaugeFiltersConfig();
    const mount = document.getElementById('ppGaugeFiltersMount');
    const cards = document.getElementById('ppGaugeFilterCards');
    const labelEl = document.getElementById('ppGaugeFiltersLabel');
    if (!mount || !cards) return;

    const fp = cfg && typeof cfg.filterParam === 'string' ? cfg.filterParam : '';
    const filters = (cfg && Array.isArray(cfg.filters)) ? cfg.filters : [];
    if (!fp || !filters.length) {
      mount.style.display = 'none';
      return;
    }

    if (labelEl && cfg.label) labelEl.textContent = cfg.label;

    var spRead =
      queryParams && typeof queryParams.getAll === 'function'
        ? queryParams
        : new URLSearchParams(window.location.search);
    var selected = spRead.getAll(fp).map(String);

    cards.innerHTML = filters.map(function (f) {
      var pv = String(f.paramValue);
      var encVal = encodeURIComponent(pv);
      var label = String(f.label || pv);
      var dis = Boolean(f.disabled);
      var active =
        selected.length > 0 ? gaugeParamSelected(selected, pv) : Boolean(f.active);
      var activeCls = active ? ' is-active' : '';
      var inner = '<div class="pp-filter-card__checkbox"></div><span class="pp-filter-card__title">' +
        escapeHtml(label) + '</span>';
      if (dis) {
        return (
          '<span class="pp-filter-card pp-gauge-filter-card pp-gauge-filter-card--disabled' +
          activeCls +
          '" aria-disabled="true" data-pp-gauge-value="' +
          encVal +
          '">' +
          inner +
          '</span>'
        );
      }
      var href = ppBuildNativeGaugeUrl(fp, f.paramValue);
      return (
        '<a class="pp-filter-card pp-gauge-filter-card' +
        activeCls +
        '" href="' +
        escAttrHref(href) +
        '" aria-pressed="' +
        (active ? 'true' : 'false') +
        '" data-pp-gauge-value="' +
        encVal +
        '">' +
        inner +
        '</a>'
      );
    }).join('');

    mount.style.display = '';
  }

  function rowMatchesTableFilters(row) {
    const tagSet = new Set(
      String(row.dataset.tags || '')
        .toLowerCase()
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    );
    const tagOk = activeQuickFilters.size === 0 ||
      Array.from(activeQuickFilters).some(t => tagSet.has(t));

    return tagOk;
  }

  function applyQuickFiltersToSingleTable() {
    const rows = document.querySelectorAll('.pp-table tbody tr.pp-row-link');
    if (!rows.length) return;
    rows.forEach(r => {
      r.style.display = rowMatchesTableFilters(r) ? '' : 'none';
    });
  }

  function applyQuickFiltersToGroupedTables() {
    const rows = document.querySelectorAll('.pp-groups-container .pp-table tbody tr.pp-row-link');
    if (!rows.length) return;
    rows.forEach(r => {
      r.style.display = rowMatchesTableFilters(r) ? '' : 'none';
    });
  }

  function applyAllRowFilters() {
    applyQuickFiltersToSingleTable();
    applyQuickFiltersToGroupedTables();
  }

  function getInitialTagsFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);

      // Preferred: our custom param
      const raw = (params.get('pp_tags') || params.get('tags') || '').trim();
      if (raw) {
        return raw
          .split(',')
          .map(s => s.trim().toLowerCase())
          .filter(Boolean);
      }

      // Shopify native collection filter: ?constraint=tag1+tag2
      // NOTE: URLSearchParams decodes '+' as space.
      const constraintRaw = (params.get('constraint') || '').trim();
      if (!constraintRaw) return [];

      return constraintRaw
        .split(/[+,\s]+/g)
        .map(s => s.trim().toLowerCase())
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function preselectQuickFiltersFromUrl() {
    const initialTags = getInitialTagsFromUrl();
    if (!initialTags.length) return;

    // Activate any quick-filter cards that match tags in the URL.
    initialTags.forEach(tag => activeQuickFilters.add(tag));

    // Mark matching cards as active (if they exist)
    document.querySelectorAll('.pp-quick-filter-card').forEach(card => {
      const tag = (card.dataset.qfTag || '').toLowerCase();
      if (activeQuickFilters.has(tag)) card.classList.add('is-active');
    });

    // Apply filtering to whichever mode we're in
    applyAllRowFilters();
  }

  /**
   * Sync the grouped-mode pill selection (e.g. from a hub page sublink like
   * ?pp_group=1-25-mil-poly-tubing) from the current URL, without narrowing
   * collection.products via a native filter. Native filtering happens server-side before
   * this section even renders, which would make every other group's table not render at
   * all - not just hide its pill. This keeps every group's real data in the DOM
   * (client-side toggle via the existing data-filter-target mechanism), so other
   * gauges/groups stay directly selectable.
   *
   * Always clears activeFilters first and always calls updateVisibility(), so this is
   * safe to call repeatedly - on initial load, and again after every native-filter AJAX
   * morph (see the filter:update handler below). Without the clear, a group selected by an
   * earlier manual pill click could linger in activeFilters after a native filter change
   * replaces the DOM, potentially hiding the only group left standing (its id just never
   * matches anything in the new markup). Treating the URL as the single source of truth on
   * every resync avoids that - a native filter change intentionally starts group selection
   * fresh from whatever's actually in the URL, same as the quick-filter tag system already does.
   */
  function preselectGroupFromUrl() {
    activeFilters.clear();

    // Reset any cosmetic gauge-checkbox mirroring left over from a prior selection before
    // this resync recomputes it below - otherwise a checkbox could stay visually checked
    // for a group that's no longer active after a deep link or native-filter morph.
    document.querySelectorAll('.pp-filter-card[data-gauge-value]').forEach(function (c) {
      ppCosmeticSyncGaugeCheckbox(c.getAttribute('data-gauge-value'), false);
    });

    const handle = (new URLSearchParams(window.location.search).get('pp_group') || '').trim().toLowerCase();
    if (handle) {
      const card = document.querySelector('.pp-filter-card[data-group-handle="' + handle + '"]');
      if (card && card.hasAttribute('data-filter-target')) {
        activeFilters.add(card.dataset.filterTarget);
        card.classList.add('is-active');
        ppCosmeticSyncGaugeCheckbox(card.getAttribute('data-gauge-value'), true);
      }
    }

    updateVisibility();
  }

  function getRobustParams() {
    // Handles cases where the querystring was accidentally double/triple encoded.
    // Example broken URL:
    //   ?pp_collection%25253Dfoo%2526pp_tags%253Dtag1%252Ctag2%26pp_title%3DMy%20Title
    // We decode a few times and re-parse.
    const raw = (window.location.search || '').replace(/^\?/, '');

    const candidates = [];
    // 1) Normal
    candidates.push(raw);

    // 2) Decoded 1..3 times (guarded)
    let cur = raw;
    for (let i = 0; i < 3; i++) {
      try {
        const next = decodeURIComponent(cur);
        if (next === cur) break;
        cur = next;
        candidates.push(cur);
      } catch (e) {
        break;
      }
    }

    // Choose the first candidate that contains any of our params (or Shopify's constraint)
    const picked = candidates.find(q => /(^|&)(pp_(title|tags|collection)|constraint)=/i.test(q)) || raw;

    try {
      return new URLSearchParams(picked);
    } catch (e) {
      return new URLSearchParams(raw);
    }
  }

  function applyTitleOverrideFromUrl() {
    // Title priority:
    // 1) pp_title URL override
    // 2) collection metafield custom.page_heading exposed on results-list
    // 3) otherwise leave the existing page title alone
    try {
      const params = getRobustParams();
      const rl = document.querySelector('results-list');
      const mfTitleRaw = (rl && rl.dataset.ppPageHeading ? rl.dataset.ppPageHeading : '').trim();
      const urlTitleRaw = (params.get('pp_title') || '').trim();

      let t = '';

      if (urlTitleRaw) {
        t = urlTitleRaw;
        try { t = decodeURIComponent(urlTitleRaw); } catch (e) {}
      } else if (mfTitleRaw) {
        t = mfTitleRaw;
      }

      if (!t) return;

      // Prefer common Shopify collection title selectors, then fallback to first H1
      const titleTargets = [
        '.collection-hero__title',
        '.collection-hero__title span',
        '.collection-hero__text-wrapper h1',
        'header.collection-hero h1',
        'main h1',
        'h1'
      ];

      const h1 = titleTargets
        .map(sel => document.querySelector(sel))
        .find(Boolean);

      if (h1) h1.textContent = t;

      // Also update the document title (keep the trailing site name if present)
      const parts = (document.title || '').split('|').map(p => p.trim()).filter(Boolean);
      if (parts.length >= 2) {
        document.title = `${t} | ${parts[parts.length - 1]}`;
      } else {
        document.title = t;
      }
    } catch (e) {}
  }

  function applyCollectionOverrideFromUrl() {
    // If the hub card passed a collection handle, ensure we're on that collection.
    // We redirect because Liquid can’t swap the `collection` object at runtime.
    try {
      const params = getRobustParams();
      const desired = (params.get('pp_collection') || '').trim();
      if (!desired) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      const cleanDesired = desired.replace(/^\/+/, '').replace(/\/+$/, '');

      // Determine the current collection handle robustly.
      // 1) Prefer the collection page URL (/collections/<handle>)
      // 2) Fallback to the results-list dataset (present on some templates)
      let currentHandle = '';
      const path = (window.location.pathname || '').replace(/\/+$/, '');
      const m = path.match(/\/collections\/([^\/]+)/i);
      if (m && m[1]) {
        try { currentHandle = decodeURIComponent(m[1]); } catch (e) { currentHandle = m[1]; }
      }
      if (!currentHandle) {
        currentHandle = (document.querySelector('results-list')?.dataset.currentCollectionHandle || '').trim();
      }

      // If we're already on the desired collection, do NOT redirect.
      if (currentHandle && currentHandle === cleanDesired) return;

      // Build redirect URL to the collection, preserving ALL query params except pp_collection.
      // This is critical so Shopify's native filters like `constraint=...` are not dropped.
      const out = new URLSearchParams(params.toString());
      out.delete('pp_collection');

      const qs = out.toString();
      const target = `${root}collections/${encodeURIComponent(cleanDesired)}${qs ? `?${qs}` : ''}`;

      // Avoid infinite loops if something goes sideways.
      if (window.location.href !== target) {
        window.location.assign(target);
      }
    } catch (e) {}
  }

    // Scroll arrows for subcategory cards
  const scroller = document.getElementById('ppFilterCards');
  const btnLeft = document.querySelector('.pp-scroll-left');
  const btnRight = document.querySelector('.pp-scroll-right');

  function updateScrollButtons(){
    if (!scroller || !btnLeft || !btnRight) return;
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    btnLeft.disabled = scroller.scrollLeft <= 2;
    btnRight.disabled = scroller.scrollLeft >= (maxScrollLeft - 2);
  }

  if (scroller && btnLeft && btnRight){
    btnLeft.addEventListener('click', () => scroller.scrollBy({ left: -280, behavior: 'smooth' }));
    btnRight.addEventListener('click', () => scroller.scrollBy({ left: 280, behavior: 'smooth' }));
    scroller.addEventListener('scroll', updateScrollButtons, { passive: true });
    window.addEventListener('resize', updateScrollButtons);
    updateScrollButtons();
  }
  function enforceSingleTableWhenConstrained(){
    const rl = document.querySelector('results-list');
    const constrained = rl && rl.dataset.ppConstrained === 'true';
    if (!constrained) return;

    // If grouped UI exists for any reason, hide it.
    const grouped = document.querySelector('.pp-groups, .pp-groups-container');
    if (grouped) {
      grouped.style.display = 'none';
    }

    // Hide grouped subcategory card row only (not gauge pills or tag quick filters).
    const subcatRow = document.querySelector('.pp-filter-row-wrapper:not(.pp-gauge-filter-row)');
    if (subcatRow && !subcatRow.classList.contains('pp-quick-filter-row')) {
      subcatRow.style.display = 'none';
    }
  }

  function initPioneerTableUI() {
    applyCollectionOverrideFromUrl();
    renderQuickFilters();
    renderGaugeFilters();
    preselectQuickFiltersFromUrl();
    preselectGroupFromUrl();
    applyTitleOverrideFromUrl();
    enforceSingleTableWhenConstrained();
  }

  // AJAX pagination: swap table rows + pagination controls in place instead of
  // a full page navigation. Uses Shopify's Section Rendering API, same
  // pattern as the theme's native quick-order-list pagination.
  let paginationLoading = false;

  function getResultsSectionId() {
    const rl = document.querySelector('results-list');
    const raw = rl ? rl.getAttribute('section-id') || '' : '';
    return raw.replace(/^shopify-section-/, '');
  }

  function extractSectionHTML(responseText, sectionId) {
    try {
      const json = JSON.parse(responseText);
      if (json && typeof json[sectionId] === 'string') return json[sectionId];
    } catch (e) {}
    return responseText;
  }

  async function loadPaginatedPage(url) {
    if (paginationLoading) return;
    const sectionId = getResultsSectionId();
    if (!sectionId) {
      window.location.href = url;
      return;
    }

    paginationLoading = true;
    const grid = document.querySelector('.p-industrial-data-grid');
    if (grid) grid.classList.add('pp-table-loading');

    try {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      const res = await fetch(fetchUrl.toString());
      const text = await res.text();
      const html = extractSectionHTML(text, sectionId);
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newTbody = doc.getElementById('pp-table-tbody');
      const liveTbody = document.getElementById('pp-table-tbody');
      if (!newTbody || !liveTbody) {
        window.location.href = url;
        return;
      }
      liveTbody.innerHTML = newTbody.innerHTML;

      const newPagination = doc.querySelector('.pp-table-pagination');
      const livePagination = document.querySelector('.pp-table-pagination');
      if (newPagination && livePagination) {
        livePagination.innerHTML = newPagination.innerHTML;
      }

      history.pushState('', '', url);

      preselectQuickFiltersFromUrl();
      applyAllRowFilters();

      const resultsEl = document.getElementById('ResultsList');
      if (resultsEl) resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      console.warn('Pagination fetch failed, falling back to full navigation', e);
      window.location.href = url;
    } finally {
      paginationLoading = false;
      if (grid) grid.classList.remove('pp-table-loading');
    }
  }

  document.addEventListener('filter:update', function () {
    var qp = new URLSearchParams(window.location.search);
    syncGaugePillsFromQueryParams(qp);
    renderGaugeFilters(qp);

    function refreshAfterFilterMorph() {
      // Independent of the gauge-pills gate below: a Mode C collection can have grouped
      // pills without gauge pills enabled, and the native filter morph replaces the group
      // markup too, so this needs to resync on every morph regardless.
      preselectGroupFromUrl();

      if (!document.getElementById('ppGaugeFiltersConfig')) return;
      renderQuickFilters();
      preselectQuickFiltersFromUrl();
      renderGaugeFilters();
      applyAllRowFilters();
    }
    [30, 120, 280, 550, 1000, 1800].forEach(function (ms) {
      setTimeout(refreshAfterFilterMorph, ms);
    });
  });

  window.addEventListener('pp-table-rows-appended', applyAllRowFilters);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPioneerTableUI);
  } else {
    initPioneerTableUI();
  }

  function updateVisibility() {
    const groups = document.querySelectorAll('[data-group-id]');
    if (activeFilters.size === 0) {
      groups.forEach(g => g.style.display = 'block');
    } else {
      groups.forEach(g => g.style.display = activeFilters.has(g.dataset.groupId) ? 'block' : 'none');
    }
  }

  /* GLOBAL CLICK LISTENER (Delegated) */
  document.addEventListener('click', function(e) {

    // 0. Pagination links -> AJAX swap instead of full navigation
    const pageLink = e.target.closest('.pp-table-pagination a');
    if (pageLink) {
      e.preventDefault();
      loadPaginatedPage(pageLink.getAttribute('href'));
      return;
    }

    // 1a. Gauge filter pills -> route through Shopify's native facets AJAX update
    // instead of the plain <a href> navigation these are built as. Without this, gauge
    // pills fall through to a real browser navigation (full page load, scroll reset to
    // top) even though the equivalent sidebar checkbox correctly uses the native
    // facets-form-component's AJAX morph and never reloads.
    const gaugeCard = e.target.closest('.pp-gauge-filter-card[href]');
    if (gaugeCard) {
      e.preventDefault();
      const facetsForm = document.querySelector('facets-form-component');
      if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(gaugeCard.getAttribute('href'));
      } else {
        // Grouped modes (Mode A) hide the sidebar and its facets-form-component entirely;
        // gauge pills can still be enabled there, so fall back to a real navigation rather
        // than silently doing nothing.
        window.location.href = gaugeCard.getAttribute('href');
      }
      return;
    }

    // 1b. Tag quick filters
    const qf = e.target.closest('.pp-quick-filter-card');
    if (qf) {
      const tag = (qf.dataset.qfTag || '').toLowerCase();
      qf.classList.toggle('is-active');
      qf.setAttribute('aria-pressed', qf.classList.contains('is-active') ? 'true' : 'false');
      if (activeQuickFilters.has(tag)) activeQuickFilters.delete(tag);
      else activeQuickFilters.add(tag);
      applyAllRowFilters();
      return;
    }
    const card = e.target.closest('.pp-filter-card');
    if (card && card.hasAttribute('data-filter-target')) {
      const id = card.dataset.filterTarget;
      card.classList.toggle('is-active');

      if (activeFilters.has(id)) {
        activeFilters.delete(id);
      } else {
        activeFilters.add(id);
      }

      updateVisibility();
      ppCosmeticSyncGaugeCheckbox(card.getAttribute('data-gauge-value'), activeFilters.has(id));
      return; // Exit so we don't trigger row clicks
    }

    // 2. ACCORDION LOGIC
    const bar = e.target.closest('.pp-group__bar');
    if (bar) {
      const body = bar.nextElementSibling;
      const isExpanded = bar.getAttribute('aria-expanded') === 'true';
      bar.setAttribute('aria-expanded', !isExpanded);
      body.style.display = isExpanded ? 'none' : 'block';

      const text = bar.querySelector('.pp-group__toggle-text');
      const icon = bar.querySelector('.pp-group__toggle-icon');
      if (isExpanded) {
        if (text) text.textContent = 'Expand List';
        if (icon) icon.textContent = '+';
      } else {
        if (text) text.textContent = 'Collapse List';
        if (icon) icon.textContent = '−';
      }
      return;
    }

    // 3. ROW CLICK LOGIC
    const row = e.target.closest('.pp-row-link');
    if (row && !e.target.closest('input, button, a, form')) {
      window.location.href = row.dataset.href;
    }
  });

  // Helper: open drawer using theme trigger (most compatible)
  function openCartDrawer() {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  // Delegated AJAX add to cart
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.classList || !form.classList.contains('ajax-cart-form')) return;

    e.preventDefault();
    e.stopPropagation();

    // Sync row qty -> hidden qty
    const row = form.closest('tr') || form.closest('.pp-row-link');
    const qtyInput = row ? row.querySelector('.pp-qty-input') : null;
    const qtyHidden = form.querySelector('.pp-qty-hidden');

    let qty = 1;
    if (qtyInput) {
      const n = parseInt(qtyInput.value, 10);
      qty = Number.isFinite(n) && n > 0 ? n : 1;
    }
    if (qtyHidden) qtyHidden.value = String(qty);

    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });

      if (!res.ok) {
        const err = await res.json().catch(() => null);
        console.warn('Add to cart failed', err);
        return;
      }

      const cartData = await res.json();

      // Dispatch the theme's own cart:update event instead of manually
      // patching the drawer's DOM (see p-lk-generic-product.liquid for why --
      // cart-items-component already listens for this and morphs itself
      // correctly; overwriting its innerHTML from outside corrupted it).
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartData,
          sourceId: 'ppp-table-atc',
          data: {
            itemCount: cartData.item_count,
            source: 'ppp-product-table'
          }
        }
      }));

      openCartDrawer();

    } catch (err) {
      console.warn(err);
    } finally {
      if (btn) btn.disabled = false;
    }
  }, true);
})();
